import { inject, Injectable } from '@angular/core';
import { DASHBOARD_URL_ANALYTICS } from '@const/dashboard-url-analytics/dashboard-url-analytics.const';
import { AnalyticsService } from '@providers/analytics/analytics.service';
import { StorageService } from '@providers/local-storage/storage.service';
import { EAnalyticsEvents } from '@enums/analytics/analytics-events.enum';

@Injectable({
  providedIn: 'root',
})
export class DashboardRedirectService {
  private readonly defaultDashboardPath: string = '/dashboard/phones';

  private window: Window = inject(Window);
  private analyticsService: AnalyticsService = inject(AnalyticsService);
  private storageService: StorageService = inject(StorageService);

  public saveLastDashboardPath(): void {
    const currentPath: string = this.window.location.pathname;
    if (currentPath.includes('dashboard/') && !currentPath.includes('account')) {
      this.storageService.set('lastDashboard', currentPath);
    }
  }

  public getLastDashboardPath(): string {
    return this.storageService.get('lastDashboard') || this.defaultDashboardPath;
  }

  public trackRedirectEvent(): void {
    const lastPath: string = this.getLastDashboardPath();
    const eventName: EAnalyticsEvents = DASHBOARD_URL_ANALYTICS[lastPath];
    if (eventName) {
      this.analyticsService.sendEvent(eventName, {});
    }
  }
}
